import dashArrayFor from "../../Utils/dashArrayFor";
import { createMapElementVectorGridIcon } from "./createMapElementVectorGridIcon";

const POINT_STYLE_DEFAULT_Z_INDEX = 300;
const LINESTRING_STYLE_DEFAULT_Z_INDEX = 200;
const POLYGON_STYLE_DEFAULT_Z_INDEX = 100;

const createPointStyle = style => {
  const { iconStyle } = style;
  if (!iconStyle) return {};

  const { width: anchor, color, opacity } = iconStyle;
  const { zIndexOffset } = style;

  return {
    anchor,
    color,
    opacity,
    fillColor: color,
    fillOpacity: opacity,
    icon: createMapElementVectorGridIcon(iconStyle),
    // For now we consider all markers as clickable. We could be more precise whether
    // markers are clickable or not in the future by taking into account if it has an
    // information window or if it's a city walk waypoint etc. but it could be a bit
    // complex to handle all cases.
    isClickable: true,
    // Add a higher zIndex value for the Points so they are rendered
    // over all other geometries
    zIndex: POINT_STYLE_DEFAULT_Z_INDEX + zIndexOffset
  };
};

const createLineStringStyle = elementStyle => {
  const style = elementStyle?.borderStyle || elementStyle;
  if (!style) return { opacity: 0 };

  const { width: weight, color, opacity, style: strokeStyle } = style;
  const { zIndexOffset } = elementStyle;

  return {
    weight,
    color,
    opacity,
    fillColor: color,
    fillOpacity: opacity,
    dashArray: strokeStyle && dashArrayFor(strokeStyle),
    zIndex: LINESTRING_STYLE_DEFAULT_Z_INDEX + zIndexOffset
  };
};

const createPolygonStyle = style => {
  const { width: weight, color, opacity, style: strokeStyle } = style?.borderStyle || {};
  const { color: fillColor, opacity: fillOpacity } = style?.backgroundStyle || {};
  const { zIndexOffset } = style;

  return {
    weight,
    color,
    opacity,
    dashArray: strokeStyle && dashArrayFor(strokeStyle),
    fillColor,
    fillOpacity,
    fill: !!fillColor,
    zIndex: POLYGON_STYLE_DEFAULT_Z_INDEX + zIndexOffset
  };
};

export default {
  Point: createPointStyle,
  LineString: createLineStringStyle,
  Polygon: createPolygonStyle
};
